import { render, staticRenderFns } from "./Aerodrome.vue?vue&type=template&id=2657965e&"
import script from "./Aerodrome.vue?vue&type=script&lang=js&"
export * from "./Aerodrome.vue?vue&type=script&lang=js&"
import style0 from "./Aerodrome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports